import React, { forwardRef } from "react";
import { Input, Label } from "reactstrap";
import Select from "react-select";

const InputControl = forwardRef((props, ref) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      // state.isFocused can display different borderColor if you need it
      borderColor: state.isFocused
        ? "#c6daef"
        : props.isValid
        ? "#c6daef"
        : "red",
      boxShadow: state.isFocused
        ? "0 0 0 4px rgb(143 189 232 / 25%)"
        : props.isValid
        ? "#c6daef"
        : "none",
      borderRadius: "8px",
      // overwrittes hover style
      "&:hover": {
        borderColor: state.isFocused
          ? "#c6daef"
          : props.isValid
          ? "#ddd"
          : "red",
      },
    }),
    dropdownIndicator: (styles, state) => ({
      ...styles,
      color: state.isFocused ? "hsl(0, 0 , 0, 80%)" : "hsl(0, 0 , 0, 60%)",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    placeholder: (base) => ({
      ...base,
      color: "black",
    }),
  };
  const { label, type, value, ...rest } = props;
  let inputElement = null;
  switch (type) {
    case "react-select":
      inputElement = (
        <Select
          styles={customStyles}
          closeMenuOnSelect
          {...rest}
          value={value}
          ref={ref}
        />
      );
      break;
    default:
      inputElement = (
        <Input
          className={type === "password" ? `form-control pe-5` : `form-control`}
          value={value}
          type={type}
          {...rest}
          ref={ref}
        />
      );
      break;
  }
  return (
    <>
      {props.label && (
        <Label htmlFor={props.name} className="form-label">
          {props.label}
        </Label>
      )}
      {inputElement}
    </>
  );
});

export default InputControl;
